import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NewRelicService } from 'app/domain/payment-domain/services/newRelic.service';

@Injectable({
  providedIn: 'root'
})
export class LoaderSubjectService {
  private loaderSubject = new BehaviorSubject(false);
  private newRelicService = inject(NewRelicService);

  isLoading$ = this.loaderSubject.asObservable();

  showLoader() {
    if (this.loaderSubject.getValue() !== undefined && this.loaderSubject.getValue() !== null) {
      this.newRelicService.addPageAction('SHOW_LOADER', {
        component: 'LoaderSubjectService',
        action: 'showLoader',
        detail: 'Muestra el loader',
        timestamp: new Date().toISOString()
      });
      this.loaderSubject.next(true);
    }
  }

  closeLoader() {
    this.newRelicService.addPageAction('CLOSE_LOADER', {
      component: 'LoaderSubjectService',
      action: 'closeLoader',
      detail: 'Oculta el loader',
      timestamp: new Date().toISOString()
    });
    this.loaderSubject.next(false);
  }
}